import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const ModalStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .formField {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    label {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      color: ${color.text.label};
      margin-bottom: 8px;
    }
  }

  .moveRow {
    display: flex;
    align-items: flex-end;
    gap: 12px;

    /* SelectChangeStatusFunnel fija 220 px en línea; aquí ocupa su columna */
    .MuiAutocomplete-root {
      width: 100% !important;
    }
  }

  .moveArrow {
    display: flex;
    align-items: center;
    height: 40px;
  }
`

// Los usa también modal-delete-tag
export const FormGridContainer = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FormGridItem = styled(Grid)`
  display: flex;
  flex-direction: column;
`

export const CenteredIconGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ArrowIcon = styled(ArrowForwardIcon)`
  margin-top: 35px;
  font-size: 5.5em;
`
